
/* this component is used just for importing style (avoid less-loader issue) */
export default {}



// WEBPACK FOOTER //
// ./~/vux/src/mixins/prevent-body-scroll.css.vue